import { Flex as NbFlex } from 'native-base';

import { addWithConfig } from '../../utils';

export const Flex = NbFlex;

export default addWithConfig(Flex);
